/* DSL Search suggestions — sticky list under search bar with popular queries */
(function(){
  var POP = ["Cleansing oil","Vitamine C","Heartleaf","Anua","Routine","Sunscreen","Mask"];
  var input = document.querySelector("input[type=search][name=q]");
  if (!input) return;
  var list = document.createElement("ul");
  list.className = "dsl-search-pop";
  list.setAttribute("role", "list");
  list.style.display = "none";
  list.innerHTML = POP.map(function(q){ return "<li><a href=\"/search?q=" + encodeURIComponent(q) + "\">" + q + "</a></li>"; }).join("");
  input.parentNode.appendChild(list);
  input.addEventListener("focus", function(){ list.style.display = "block"; });
  input.addEventListener("blur", function(){ setTimeout(function(){ list.style.display = "none"; }, 200); });
})();